module.exports = __webpack_public_path__ + "img/calendar-plus.52f1767e.svg";